import {
  enumInventoryTagStatus,
  InventoryTagStatus,
} from '@rematter/frontend-lib-api-client';
import { Badge } from '@rematter/ui-web';

import { useTranslations } from '../../i18n/useTranslations';

type InventoryTagStatusBadgeProps = {
  status: InventoryTagStatus;
};

const STATUS_BADGE_COLOR: Record<
  InventoryTagStatus,
  'neutral' | 'primary' | 'success' | 'warning' | 'failure'
> = {
  [enumInventoryTagStatus.Active]: 'success',
  [enumInventoryTagStatus.InInventory]: 'success',
  [enumInventoryTagStatus.Draft]: 'primary',
  [enumInventoryTagStatus.Confirmed]: 'primary',
  [enumInventoryTagStatus.InTransfer]: 'warning',
  [enumInventoryTagStatus.Loaded]: 'warning',
  [enumInventoryTagStatus.Reserved]: 'warning',
  [enumInventoryTagStatus.PendingPurchase]: 'warning',
  [enumInventoryTagStatus.Shipped]: 'neutral',
  [enumInventoryTagStatus.Sold]: 'neutral',
  [enumInventoryTagStatus.Transferred]: 'neutral',
  [enumInventoryTagStatus.Revised]: 'failure',
  [enumInventoryTagStatus.Cancelled]: 'failure',
  [enumInventoryTagStatus.Voided]: 'failure',
};

export const InventoryTagStatusBadge = ({
  status,
}: InventoryTagStatusBadgeProps) => {
  const t = useTranslations();

  return (
    <Badge
      color={STATUS_BADGE_COLOR[status]}
      className="@InventoryTagStatusBadge"
    >
      {t.tagsListView.statusTypes[status]}
    </Badge>
  );
};
